<template>
	<view class="search-top-wrap">
		<view class="search-top flex">
			<input v-bind="inputAttrs" class="search-input" @click="outSearch" v-model="localValue" type="text" />
			<van-icon v-if="inputAttrs.clearable" name="clear" class="clear-icon" color="#999999" size="22" @click="clearInput" />
			<button v-if="inputAttrs.showSearch" class="search-btn" @click="nextSearch">搜索</button>
		</view>
	</view>
</template>

<script setup>
import { omit } from 'lodash-es';
import { computed, useAttrs } from 'vue';

const props = defineProps({
	value: {
		type: String,
		default: '',
	},
});

const emit = defineEmits(['input', 'outSearch', 'search', 'clear']);

const model = defineModel({ type: String, default: '' });

const attrs = useAttrs();

const inputAttrs = computed(() => ({
	showSearch: true,
	placeholder: '产品名称/型号规格/厂家/商品描述',
	clearable: false,
	...omit(attrs, ['value']),
}));

const localValue = computed({
	get() {
		return model.value ?? props.value;
	},
	set(val) {
		model.value = val;
		emit('input', val);
	},
});

function outSearch() {
	emit('outSearch');
}

function nextSearch() {
	emit('search', localValue.value);
}

function clearInput() {
	localValue.value = '';
	emit('clear');
	emit('search', '');
}
</script>

<style lang="scss" scoped>
.search-top-wrap {
	background: #fff;
	flex: 1;
}
.clear-icon {
	color: #999999;
	cursor: pointer;
}
.search-top {
	border: 1.5px solid #455bd9;
	border-radius: 7px;
	align-items: center;
	display: flex;
	height: 34px;
	padding: 2px 1px 2px 2px;

	background: #fff;
	.search-input {
		color: #595959;
		font-size: 12px;
		flex: 1;
		padding-left: 10px;
		padding-right: 10px;

		&::placeholder {
			color: grey;
			overflow: hidden;
			text-overflow: clip;
			white-space: pre;
			word-break: keep-all;
			pointer-events: none;
		}
	}
	.search-btn {
		border-radius: 5px;
		width: 60px;
		height: 30px;
		background: #455bd9;
		font-size: 13px;
		font-weight: 500;
		font-variation-settings: 'opsz' auto;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
	}
}
</style>
